import React, { useState, useEffect, useRef } from "react";
import langData from "../locales/langData.json";


const StickyTabs = ({ wrapperMultiplier = 4, language }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const careerworks = langData[language].carrerworks;

  const wrapperRef = useRef(null);
  const frameRef = useRef(null);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const count = careerworks.tabcon.length; 

    const handleScroll = () => {
      if (frameRef.current) return;

      frameRef.current = requestAnimationFrame(() => {
        frameRef.current = null;

        const rect = wrapper.getBoundingClientRect();
        const winH = window.innerHeight;
        const total = rect.height;

        if (rect.top <= 0 && Math.abs(rect.top) <= Math.max(0, total - winH)) {
          const progress = Math.abs(rect.top) / Math.max(1, total - winH);
          const idx = Math.min(count - 1, Math.floor(progress * count));
          setActiveIndex(idx);
        } else if (rect.top > 0) {
          setActiveIndex(0);
        } else if (Math.abs(rect.top) > Math.max(0, total - winH)) {
          setActiveIndex(count - 1);
        }
      });
    };

    // Run again when language changes
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    };
  }, [language, careerworks]); 

  return (
    <div
      ref={wrapperRef}
      className="sticky-wrapper"
      style={{ height: `${wrapperMultiplier}00vh` }}
    >
      <div className="sticky-container">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-6">
              <p className="sec-top-titl">{careerworks.toptitle}</p>
              <h2 className="sec-title">{careerworks.title}</h2>
            </div>
            <div className="col-md-6"></div>
          </div>

          <center>
            <div className="tab-icon-btn-con">
              {careerworks.tabcon.map((item, i) => (
                <div
                  key={i}
                  className={`tab-btn-icon ${activeIndex === i ? "active" : ""}`}
                  onClick={() => setActiveIndex(i)}
                >
                 <img src={`/${item.img}`} alt="icon" />

                </div>
              ))}
            </div>

            <div className="ans-con block-view">
              {careerworks.tabcon.map((item, i) => (
                <h3 key={i} className={activeIndex === i ? "show" : "hide"}>
                  {item.con}
                </h3>
              ))}
            </div>
          </center>
        </div>
      </div>
    </div>
  );
};

export default StickyTabs;
